import { AnimatePresence } from "motion/react";
import ServiceLocator from "../../../../../domain/service-locator";
import MinpakuAudioPlayerComponent from "../../components/player/minpaku-audio-player-component";

export const MinpakuAudioPlayerContainer = () => {
  const currentTrack = ServiceLocator.GuidePlayerModule.currentTrack.watch();
  return (
    <AnimatePresence>
      {currentTrack && (
        <>
          <MinpakuAudioPlayerComponent />
        </>
      )}
    </AnimatePresence>
  );
};
